module.exports = __webpack_public_path__ + "static/logo-footer-0a15a918ba999e11a3db6b17a36cc57e.svg";